const CHARACTER_LIMITS = {
  headline: 30,
  description: 90,
  callout: 25,
  structured_snippet: 25,
  sitelink_text: 25,
  sitelink_description: 90,
  sitelink_final_url: 2048,
  display_path: 15,
  business_name: 25,
  final_url: 2048,
};

const validateRow = (row) => {
  const { assetType } = row;
  const validTypes = ["final_url", "business_name", "headline", "description", "sitelink", "callout", "structured_snippet", "display_path", "phone_call"];

  if (!validTypes.includes(assetType)) {
    return `Invalid asset type "${assetType}". Expected: ${validTypes.join(", ")}.`;
  }

  if (assetType === "final_url") {
    if (!row.text) return "Final URL is required.";
    if (row.text.length > CHARACTER_LIMITS.final_url) return "Final URL exceeds 2048 characters.";
    return null;
  }
  if (assetType === "business_name") {
    if (!row.text) return "Business name is required.";
    if (row.text.length > CHARACTER_LIMITS.business_name) return "Business name exceeds 25 characters.";
    return null;
  }
  if (assetType === "display_path") {
    if (!row.text) return "Display path is required.";
    if (row.text.length > CHARACTER_LIMITS.display_path) return "Display path exceeds 15 characters.";
    return null;
  }
  if (assetType === "phone_call") {
    if (!row.phoneNumber) return "Phone number is required.";
    if (!row.countryCode) return "Country code is required.";
    return null;
  }
  if (assetType === "sitelink") {
    if (!row.sitelinkText) return "Sitelink text is required.";
    if (row.sitelinkText.length > CHARACTER_LIMITS.sitelink_text) return `Sitelink text exceeds ${CHARACTER_LIMITS.sitelink_text} characters.`;
    if (row.description1 && row.description1.length > CHARACTER_LIMITS.sitelink_description) return `Sitelink description 1 exceeds ${CHARACTER_LIMITS.sitelink_description} characters.`;
    if (row.description2 && row.description2.length > CHARACTER_LIMITS.sitelink_description) return `Sitelink description 2 exceeds ${CHARACTER_LIMITS.sitelink_description} characters.`;
    if (!row.finalURL) return "Sitelink final URL is required.";
    return null;
  }

  const limit = CHARACTER_LIMITS[assetType];
  if (!row.text) return `${assetType} text is required.`;
  if (limit && row.text.length > limit) return `Text exceeds ${limit} character limit (${row.text.length} chars).`;
  return null;
};

export const validateRows = (rows) => {
  const seen = {};
  return rows.map((row) => {
    const baseError = validateRow(row);
    if (baseError) return baseError;

    let key;
    if (row.assetType === "sitelink") key = `${row.assetType}:${row.sitelinkText}:${row.finalURL}`;
    else if (row.assetType === "phone_call") key = `${row.assetType}:${row.phoneNumber}:${row.countryCode}`;
    else key = `${row.assetType}:${row.text}`;

    if (seen[key]) return "Duplicate entry.";
    seen[key] = true;
    return null;
  });
};

export { CHARACTER_LIMITS };